export default class PersonPhoneArchivedDomainService {
    static fromJSON(json) {
        return Object.assign({}, json);
    }
}
